import { Box, useTheme } from '@mui/material';
import React from 'react'
import { Bar, Pie, Line } from 'react-chartjs-2'

function SingleLineChart({ data, labels }) {
    const { typography } = useTheme()
    

    return (

        <Line style={{ overflow: 'scroll' }}
            options={{
                responsive: true,
                maintainAspectRatio: true,
                animation: false,
                plugins: {
                    legend: {
                        position: 'top',
                        display: true
                    },
                    title: {
                        display: false,
                        position: 'left',
                        text: 'Temperature in Celsius Degree',
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    },
                    filler: {
                        propagate: true
                    }

                },
                spacing: 1,
                aspectRatio: 3,
                scales: {
                    y: {
                        ticks: {
                            // color: 'yellow',
                            font: {
                                size: 10,
                            }
                        }
                    },
                    x: {
                        ticks: {
                            // color: 'inherit',
                            font: {
                                size: 10
                            }
                        }
                    }
                }
            }}
            data={{
                labels: labels,
                datasets: data

            }} />


    )
}

export default SingleLineChart
